/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { DedicatedEndpointStatusDocument } from '@fai/friendli-suite/generated/client/graphql';
import client from '@fai/friendli-suite/shared/apollo/base-link';

export const getEndpointStatus = async ({ endpointId }: { endpointId: string }) => {
  const { data } = await client.query({
    query: DedicatedEndpointStatusDocument,
    variables: { endpointId },
    fetchPolicy: 'network-only',
  });

  return data.dedicatedEndpoint?.status;
};
